/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
};
export default {
    //域名映射配置
  domainMapping: {
    list:`${base.url}/auth/domainMapping/list`,
    save: `${base.url}/auth/domainMapping/save`,
    edit: `${base.url}/auth/domainMapping/edit`,
    del: `${base.url}/auth/domainMapping/del`,
    },
  //用户行为监控
  userMonitor:{
    list:`${base.url}/auth/userMonitor/list`,
  },

  userTeam:{
    list: `${base.url}/newmis36/team/list`,
    queryTeamByUserId: `${base.url}/newmis36/userTeam/queryTeamByUserId`,
    edit: `${base.url}/newmis36/userTeam/edit`,
  },
};


